import { render, staticRenderFns } from "./mfa_code.vue?vue&type=template&id=1a605398&scoped=true"
import script from "./mfa_code.vue?vue&type=script&lang=js"
export * from "./mfa_code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a605398",
  null
  
)

export default component.exports